module.exports = __webpack_public_path__ + "img/img_card_error_04@2x.f4c5533e.png";